export default __webpack_public_path__ + "static/media/i56.6f04012e.svg";